import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import http from '@/http';

const state: RiskProfileItemState = {
  riskProfileItems: [],
};

const getters: GetterTree<RiskProfileItemState, RootState> = {};

const actions: ActionTree<RiskProfileItemState, RootState> = {
  fetchList({ commit }, options) {
    return http.v1.rpi.fetchList(options).then((response) => {
      if (response.data.data) {
        commit('SET_RISK_PROFILE_ITEMS', response.data.data);
      }
      return response;
    });
  },
};

const mutations: MutationTree<RiskProfileItemState> = {
  SET_RISK_PROFILE_ITEMS(state, payload) {
    state.riskProfileItems = payload;
  },
};

const anzsco: Module<RiskProfileItemState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default anzsco;
